import { z } from "zod";
import { MetaSchema } from "./shared";

export const WalletTransactionEventSchema = z.object({
  id: z.string().uuid(),
  transaction_type: z.string(),
  coin: z.string(),
  type: z.string().nullable(),
  value: z.string(),
  amount: z.string(),
  fee: z.string(),
  tracerKey: z.number().nullable(),
  useGGold: z.string().nullable(),
  useProfit: z.string().nullable(),
  hash: z.string().nullable(),
  created_at: z.string().datetime(),
  completedAt: z.string().datetime().nullable(),
  status: z.string(),
  description: z.string().nullable(),
});

const WalletsTransactionsLatestEventsResponse = z.object({
  data: z.array(WalletTransactionEventSchema),
  meta: MetaSchema.default,
});

export type WalletsTransactionsLatestEventsResponseType = z.infer<
  typeof WalletsTransactionsLatestEventsResponse
>;

export default WalletsTransactionsLatestEventsResponse;
